import quotes from "../../Images/quotes.png";
import homeAssistant from "../../Images/homeassistant.png";
import wifiIcon from "../../Images/wifi.png";
import accountIcon from "../../Images/account.png";
import rotaIcon from "../../Images/rota.png";

import style from './Dashboard.module.css';
import {getMe} from "../../Auth/Tokens";
import {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import {deleteJwt} from "../../Auth/Auth";

function Dashboard() {
    const [user, setUser] = useState<any>(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);
    const navigate = useNavigate();

    useEffect(() => {
        async function fetchUser() {
            try {
                const data = await getMe();
                setUser(data);
            } catch (err: any) {
                if (err.status === 401) {
                    deleteJwt();
                    navigate("/login");
                } else {
                    deleteJwt();
                    setError("Failed to fetch user");
                }
            } finally {
                setLoading(false);
            }
        }

        fetchUser();
    }, [navigate]);

    if (loading) {
        return <div>Loading...</div>;
    }
    if (error) {
        return <div>{error}</div>;
    }

  return (
    <IndexHeader userName={user?.name} />
  );
}

function IndexHeader({ userName }: { userName: string }) {
    const navigate = useNavigate();
    return (
      <div className="header">
      <div className={style.header}>
        <h2>Welcome {userName}</h2>
          <h2>11a Trafalgar Place Dashboard</h2>
      </div>
          <div className={style.content}>
              <div className={style.center}>
                  <img src={quotes} alt={"Quotes"} id={"quotes"} onClick={() => { navigate("/quotes") }} />
                  <img src={accountIcon} alt={"Account"} id={"houseAccount"} onClick={() => { navigate("/account/overview") }} />
                  <img src={rotaIcon} alt={"Rota"} id={"rota"} onClick={() => { navigate("/rota") }} />
                  <img src={wifiIcon} alt={"WiFi"} id={"wifiNetworks"} onClick={() => { navigate("/info/wifi") }} />
                  <img src={homeAssistant} alt={"HomeAssistant"} id={"homeAssistant"} onClick={() => { navigate("https://homeassistant.uni.pittswilliams.co.uk/") }} />
              </div>
          </div>
      </div>
  )
}

export default Dashboard;
